
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.507 1.226c.284 0 .513.23.513.513v.215c0 .706-.45 1.33-1.12 1.554a.612.612 0 00-.419.581v.215a.513.513 0 11-1.026 0v-.215c0-.706.45-1.33 1.12-1.554a.612.612 0 00.42-.581v-.215c0-.283.229-.513.512-.513zM7.455.2c.284 0 .513.23.513.513v.215c0 .706-.45 1.33-1.12 1.554a.612.612 0 00-.419.581v.215a.513.513 0 01-1.026 0v-.215c0-.706.45-1.33 1.12-1.554a.612.612 0 00.42-.581V.713c0-.283.229-.513.512-.513z","fill":"#593289","stroke":"#593289","stroke-width":".1"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.651 14.353a.654.654 0 010 1.309h-7.42a.654.654 0 110-1.309h7.42z","fill":"#593289"}}),_c('mask',{attrs:{"id":"a","fill":"#fff"}},[_c('path',{attrs:{"d":"M.25 6.382c0-.487.395-.882.882-.882h11.361c.487 0 .882.395.882.882v.493a6.563 6.563 0 01-13.125 0v-.493z"}})]),_c('path',{attrs:{"d":"M1.132 6.8h11.361V4.2H1.132v2.6zm10.943-.418v.493h2.6v-.493h-2.6zM1.55 6.875v-.493h-2.6v.493h2.6zm5.263 5.262A5.262 5.262 0 011.55 6.875h-2.6a7.862 7.862 0 007.863 7.863v-2.6zm5.262-5.262a5.263 5.263 0 01-5.262 5.262v2.6a7.863 7.863 0 007.862-7.862h-2.6zm.418-.075a.418.418 0 01-.418-.418h2.6A2.182 2.182 0 0012.493 4.2v2.6zM1.132 4.2A2.182 2.182 0 00-1.05 6.382h2.6c0 .23-.187.418-.418.418V4.2z","fill":"#593289","mask":"url(#a)"}}),_c('path',{attrs:{"d":"M12.25 7.5h1.5a1.5 1.5 0 011.5 1.5v0a1.5 1.5 0 01-1.5 1.5H11.5","stroke":"#593289","stroke-width":"1.3","stroke-linejoin":"round"}})])
          )
        }
      }
    